import React from "react";

import { styled } from "@mui/material";

import PlayToggleButton from "./PlayToggleButton";
import DesktopTimeline from "./DesktopTimeline";
import ProjectionControls from "./ProjectionControls";

const Container = styled("div")({
  position: "relative",
  overflowX: "auto",
  overflowY: "hidden",
  width: "fit-content",
  maxWidth: "100%",
  display: "flex",
  flexDirection: "row",
  boxSizing: "border-box",
  backgroundColor: "#ffffff",
  border: "1px solid #6c6c6c",
  borderRadius: "8px",
  padding: "8px 12px 8px",
  minHeight: "45px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
  gap: "0",
  alignItems: "stretch",
  opacity: 0.8,
});

/**
 * Desktop view renderer for KlimaSlider.
 * Pure composition/layout; does not implement selection/timer rules.
 */
function DesktopView({
  playing,
  onTogglePlaying,
  playDisabled,
  sliderItems,
  originalItems,
  displaySelected,
  isChangeMode,
  onPickOriginalIndex,
  projectionControlsDisabled,
  szenarioItems,
  szenarioIndex,
  onScenarioChange,
  onChangeMode,
  // ForecastToggle props
  CommunicationStore,
  token,
  view,
  map,
}) {
  return (
    <Container>
      <PlayToggleButton
        playing={playing}
        onToggle={onTogglePlaying}
        disabled={playDisabled}
      />

      <DesktopTimeline
        sliderItems={sliderItems}
        originalItems={originalItems}
        displaySelected={displaySelected}
        isChangeMode={isChangeMode}
        onPickOriginalIndex={onPickOriginalIndex}
      />

      <ProjectionControls
        disabled={projectionControlsDisabled}
        mobile={false}
        szenarioItems={szenarioItems}
        szenarioIndex={szenarioIndex}
        onScenarioChange={onScenarioChange}
        isChangeMode={isChangeMode}
        onChangeMode={onChangeMode}
        CommunicationStore={CommunicationStore}
        token={token}
        view={view}
        map={map}
      />
    </Container>
  );
}

export default DesktopView;
